import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FHIRBundleEntry, FHIROrganization, ReferencedResources } from '../../../models';

@Component({
  selector: 'app-composition-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './composition-table.component.html',
  styleUrl: './composition-table.component.scss',
})
export class CompositionTableComponent {
  readonly entries = input.required<FHIRBundleEntry[]>();
  readonly referencedResources = input<ReferencedResources | null>(null);
  readonly showSourceBadge = input(false);

  readonly detalleClick = output<FHIRBundleEntry>();

  formatDate(date: string): string {
    if (!date) return '—';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getOrganizacion(entry: FHIRBundleEntry): FHIROrganization | null {
    const r = entry.resource;
    const refs = this.referencedResources();
    if (!refs || !r) return null;

    const custodianRef: string = r.custodian?.reference || r.attester?.[0]?.party?.reference || '';
    if (!custodianRef.includes('/')) return null;

    const [, orgId] = custodianRef.split('/');
    return refs.organizations?.find((o) => o.id === orgId) ?? null;
  }

  getRegion(org: FHIROrganization | null): string {
    if (!org?.address?.[0]) return 'N/A';
    const addr = org.address[0];
    return addr.city || addr.district || addr.state || 'N/A';
  }

  getSourceBadge(source: string): { color: string; icon: string; label: string } {
    if (source === 'rda-paciente') {
      return { color: 'bg-primary', icon: '👤', label: 'Paciente' };
    }
    return { color: 'bg-success', icon: '🏥', label: 'Encuentros' };
  }
}
